import React from 'react';
import { connect } from 'react-redux';
import { Trans, useTranslation, withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom'

import { Form, Button, Col, Row, Spinner } from 'react-bootstrap';
import { TEST_X_API_KEY, X_API_KEY } from '../../utils/authentication';

import { signIn, signInReset } from '../../actions/index';
import { isAuthenticated } from '../../utils/authentication';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    function changeLanguage( lang ) {
        i18n.changeLanguage(lang);
        localStorage.setItem('i18nextLng', lang);
        window.location.reload();
    }
    const lang = i18n.language;

    return (
        <button onClick={() => {changeLanguage(lang === "en" ? "zh" : "en")}}>{lang === "en" ? "中国人" : "English"}</button>
    )

}

class LoginForm extends React.Component {

    constructor() {

        super();

        this.state = {
            apiKey: '',
            errorAccessKey: false,
            loginText: "Private Workspace",
        };

        this.handleApiKey = this.handleApiKey.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onTryDemo = this.onTryDemo.bind(this);
    }

    componentDidMount() {
        this.props.signInReset();
        this.setState({loginText: this.props.t("Log_In")});
    }

    handleApiKey(e) {
        this.setState({ apiKey: e.target.value });
    }

    onSubmit(e) {

        e.preventDefault();
        e.stopPropagation();

        this.setState({
            errorAccessKey: false,
            loginText: (<div>
                <Spinner
                    style={{ marginRight: "0.25rem" }}
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
                <Trans i18nKey="Logging_in" />
            </div>),
        });

        localStorage.setItem(TEST_X_API_KEY, this.state.apiKey);

        if (!this.state.apiKey) {
            this.setState({ errorAccessKey: true, loginText: this.props.t("Log_In") });
            localStorage.removeItem(TEST_X_API_KEY);
            this.props.signInReset();
        } else {

            localStorage.setItem(TEST_X_API_KEY, this.state.apiKey);

            this.props.signIn().then(() => {
                if (this.props.authResult === true) {

                    localStorage.setItem(X_API_KEY, this.state.apiKey);
                    localStorage.removeItem(TEST_X_API_KEY);
                    this.props.signInReset();
                    this.setState({ loginText: this.props.t("Log_In") });
                } else {
                    this.setState({ errorAccessKey: true, loginText: this.props.t("Log_In") });
                    localStorage.removeItem(TEST_X_API_KEY);
                    this.props.signInReset();
                }
            });
        }
    }

    onTryDemo(e) {
        localStorage.setItem(X_API_KEY, '');
        this.setState({ isSubmitted: true });
    }

    render() {
        const { t } = this.props;

        const parameters = new URLSearchParams(this.props.location.search);
        const brand = parameters.get('brand');
        const force = parameters.get('force');

        if ( !brand && !force && isAuthenticated() === false) {
            localStorage.setItem(X_API_KEY, '');
            return (<Redirect to='/' />);
        }

        if (isAuthenticated()) {
            return (<Redirect to='/' />);
        }

        return (
            <div style={{ maxWidth: '90vh' }}>

                <Row>
                    <Col> <h2><Trans i18nKey="Tuner4TRONIC" /></h2> </Col>
                </Row>
                <Row>
                    <Col>
                        <h6 className="OsramColor">
                            <Trans i18nKey="User_log_in" />
                        </h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {/* <br /> */}
                        <Form
                            validated={this.state.validated}
                            onSubmit={this.onSubmit} >
                            <Form.Group controlId="formApiKey">
                                <Form.Label><Trans i18nKey="Access_key" /></Form.Label>
                                <Form.Control type="password" placeholder={t("Access_key")} value={this.state.apiKey} onChange={this.handleApiKey} />
                                {
                                    this.state.errorAccessKey
                                        ? <Form.Control.Feedback type="danger" > <Trans i18nKey="Access_Key_Error" /></Form.Control.Feedback>
                                        : null
                                }
                            </Form.Group>
                            <br />
                            <Button className="btn-landing" variant="primary" type="button" onClick={this.onTryDemo}>
                                <Trans i18nKey="Public_Mode_1" />
                            </Button>
                            <Button className="btn-landing" variant="secondary" type="submit">
                                {this.state.loginText}
                            </Button>
                        </Form>
                    </Col>
                </Row>
                <Row>

                    <Col>
                        <div>
                            <br />
                            <b><Trans i18nKey="Public_Mode_1" />: </b><Trans i18nKey="Public_Mode_2" /><br /><br />
                            <b><Trans i18nKey="Private_Workspace_1" />: </b><Trans i18nKey="Private_Workspace_2" />
                        </div>
                    </Col>
                </Row>
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        authResult: state.auth.result,
    };
};

const mapDispatchToProps = {
    signIn,
    signInReset,
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(withTranslation()(LoginForm)));
